import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useTranslatedOptions(list, namespace) {
  const { t } = useTranslation();
  return useMemo(
    () =>
      list.map(({ label, ...rest }) => ({
        ...rest,
        label: t(`${namespace}.${label}`),
      })),
    [t, list, namespace]
  );
}
